module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/88fc2b4cf2491304618a71d2c94acc68.png";